export default "__VITE_ASSET__DcVEVm_d__"